<template>
    <div class="bar-x-scrollable items-center custom-scrollbar">
        <slot></slot>
    </div>
</template>

<style lang="scss">
.bar-x-scrollable {
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow-x: auto;

    > * {
        flex-shrink: 0;
    }
}
</style>
